import { render, staticRenderFns } from "./agreementPage.vue?vue&type=template&id=2a5c7968&scoped=true"
import script from "./agreementPage.vue?vue&type=script&lang=js"
export * from "./agreementPage.vue?vue&type=script&lang=js"
import style0 from "./agreementPage.vue?vue&type=style&index=0&id=2a5c7968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c7968",
  null
  
)

export default component.exports